// extracted by mini-css-extract-plugin
export var ClientClaimDesc = "index-module--ClientClaimDesc--cbz1N";
export var ClientClaimLogoMb = "index-module--ClientClaimLogoMb--MCDzR";
export var ClientClaimLogoPc = "index-module--ClientClaimLogoPc--fN7mA";
export var ClientClaimLogoWrap = "index-module--ClientClaimLogoWrap--ihmZM";
export var ClientClaimWrap = "index-module--ClientClaimWrap--HCFwF";
export var Hidden = "index-module--Hidden--DERkP";